import React from "react";
import "./highlights.css";

import Pic from "../../assets/highlight_img-2.webp";
import {
  ParallaxProvider,
  ParallaxBanner,
  ParallaxBannerLayer,
} from "react-scroll-parallax";

export default function Highlights() {

  return (
    <ParallaxProvider>
      <div className="HirdaramaniReports">
        <div className="paragraph-two-column">
          <div className="paragraph-column-2" data-aos="fade-right">
            <h1 className="pillars-topic">
              Our Future First <span className="title-second-color">Pillars</span>
            </h1>
            <div className="pillars-right">
              <div className="pillars-grid">
                <div className="pillar-block">
                  <div className="pillar-label">
                    <span className="pillar-number">01</span>
                    <span className="pillar-title">Conserve</span>
                  </div>
                  <a
                    href="/conserve/"
                    className="pillar-item button-image-1"
                    aria-label="Conserve section"
                  >
                  </a>
                </div>

                <div className="pillar-block">
                  <div className="pillar-label">
                    <span className="pillar-number-2">02</span>
                    <span className="pillar-title">Empower</span>
                  </div>
                  <a
                    href="/empower/"
                    className="pillar-item button-image-2"
                    aria-label="Empower section"
                  >
                  </a>
                </div>

                <div className="pillar-block">
                  <div className="pillar-label">
                    <span className="pillar-number">03</span>
                    <span className="pillar-title">Support</span>
                  </div>
                  <a
                    href="/support/"
                    className="pillar-item button-image-3"
                    aria-label="Support section"
                  >
                  </a>
                </div>

                <div className="pillar-block">
                  <div className="pillar-label">
                    <span className="pillar-number-2">04</span>
                    <span className="pillar-title">Trust</span>
                  </div>
                  <a
                    href="/trust/"
                    className="pillar-item button-image-4"
                    aria-label="Trust section"
                  >
                  </a>
                </div>
              </div>
            </div>
          </div>


          <div className="paragraph-column-1" data-aos='fade-left'>
            <center>
              <h1 className="highlights-main-topic">
                Hirdaramani Apparel <br />
                <span className="title-second-color">
                  Sustainability Report
                </span>
              </h1>

              <div className="button-wrapper">
                <a
                  href="/H-Sustainability-Report-2024.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="zoom-button"
                >
                  2024 Sustainability Report
                </a>
              </div>
            </center>

            <div className="img-gap-s" />
            <div className="pic">
              <ParallaxBanner className="parallax-banner">
                <ParallaxBannerLayer image={Pic} speed={5} />
              </ParallaxBanner>
            </div>
          </div>
        </div>
      </div>
    </ParallaxProvider>
  );
}
